import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["count", "type"];
import React, { useState } from "react";
import { LikeRewardButton } from "../reward-button";
import { useShareUrl, useNativeShare, SocialComponents } from "../util/social-share";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export var LikeButton = function LikeButton(_ref) {
  var _ref$count = _ref.count,
    count = _ref$count === void 0 ? 0 : _ref$count,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? "confetti" : _ref$type,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("span", {
    className: "social-button like-button",
    children: [/*#__PURE__*/_jsx(LikeRewardButton, _objectSpread({
      btnClassName: "btn-default",
      type: type
    }, props)), /*#__PURE__*/_jsx("span", {
      children: (count || 0) > 0 ? "Gef\xE4llt ".concat(count, " Mal") : "Gefällt mir"
    })]
  });
};
export var CommentButton = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var count = _ref2.count,
    onClick = _ref2.onClick;
  return /*#__PURE__*/_jsxs("span", {
    ref: ref,
    className: "social-button comment-button ".concat(onClick && "clickable" || ""),
    onClick: onClick,
    children: [/*#__PURE__*/_jsx("button", {
      className: "btn btn-default",
      children: /*#__PURE__*/_jsx("i", {
        className: "fa fa-comment ".concat(count > 0 && "text-primary" || "")
      })
    }), count && "".concat(count, " Kommentar").concat(count === 1 ? "" : "e") || "Kommentieren"]
  });
});
export var ShareButton = function ShareButton(_ref3) {
  var url = _ref3.url;
  var currUrl = useShareUrl();
  url = url || currUrl;
  var _useNativeShare = useNativeShare(url),
    _useNativeShare2 = _slicedToArray(_useNativeShare, 2),
    isNative = _useNativeShare2[0],
    handleNativeShare = _useNativeShare2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showPopover = _useState2[0],
    setShowPopover = _useState2[1];
  var handleShare = function handleShare() {
    if (isNative) {
      handleNativeShare();
    } else {
      setShowPopover(function (v) {
        return !v;
      });
    }
  };
  return /*#__PURE__*/_jsxs("span", {
    className: "social-button share-button",
    onClick: handleShare,
    children: [/*#__PURE__*/_jsx("button", {
      className: "btn btn-default",
      children: /*#__PURE__*/_jsx("i", {
        className: "fa fa-share"
      })
    }), "Teilen", showPopover && /*#__PURE__*/_jsxs("div", {
      className: "popover bottom fade in",
      children: [/*#__PURE__*/_jsx("div", {
        className: "arrow"
      }), /*#__PURE__*/_jsx("h3", {
        className: "popover-title",
        children: "Teilen"
      }), /*#__PURE__*/_jsx("div", {
        className: "popover-content",
        children: Object.entries(SocialComponents).map(function (_ref4) {
          var _ref5 = _slicedToArray(_ref4, 2),
            service = _ref5[0],
            Component = _ref5[1];
          return /*#__PURE__*/_jsx(Component, {
            link: url
          }, service);
        })
      })]
    })]
  });
};
export var SocialButtons = function SocialButtons(_ref6) {
  var _ref6$className = _ref6.className,
    className = _ref6$className === void 0 ? "" : _ref6$className,
    children = _ref6.children;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: "social-buttons list-group ".concat(className),
      children: /*#__PURE__*/_jsx("div", {
        className: "list-group-item",
        children: children
      })
    }, "buttons")
  });
};
export default SocialButtons;
//# sourceMappingURL=Buttons.js.map